var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 987,
    height: 697,
    viewBox: "0 0 987 697",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-95.6423 55.4115V-55.4115L-7.62939e-05 -110.823L95.6422 -55.4115V55.4115L-7.62939e-05 110.823L-95.6423 55.4115Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.28882e-05 -110.3L95.2079 -55.1501V55.1501L-2.28882e-05 110.3L-95.2079 55.1501V-55.1501L-2.28882e-05 -110.3ZM-2.28882e-05 -111.259L-96.0766 -55.5857V55.6729L-2.28882e-05 111.259L96.0766 55.5858V-55.6729L-2.28882e-05 -111.259Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.723 55.4115V-55.4115L197.365 -110.823L293.094 -55.4115V55.4115L197.365 110.823L101.723 55.4115Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.365 -110.3L292.573 -55.1501V55.1501L197.365 110.3L102.157 55.1501V-55.1501L197.365 -110.3ZM197.365 -111.259L101.289 -55.6729V55.6729L197.365 111.346L293.442 55.6729V-55.6729L197.365 -111.259Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.175 55.4115V-55.4115L394.817 -110.823L490.46 -55.4115V55.4115L394.817 110.823L299.175 55.4115Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.817 -110.3L490.025 -55.1501V55.1501L394.817 110.3L299.609 55.1501V-55.1501L394.817 -110.3ZM394.817 -111.259L298.741 -55.6729V55.6729L394.817 111.346L490.894 55.6729V-55.6729L394.817 -111.259Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.54 55.4115V-55.4115L592.183 -110.823L687.825 -55.4115V55.4115L592.183 110.823L496.54 55.4115Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.183 -110.3L687.391 -55.1501V55.1501L592.183 110.3L496.975 55.1501V-55.1501L592.183 -110.3ZM592.183 -111.259L496.106 -55.6729V55.6729L592.183 111.346L688.259 55.6729V-55.6729L592.183 -111.259Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.906 55.4115V-55.4115L789.548 -110.823L885.277 -55.4115V55.4115L789.548 110.823L693.906 55.4115Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.548 -110.3L884.756 -55.1501V55.1501L789.548 110.3L694.34 55.1501V-55.1501L789.548 -110.3ZM789.548 -111.259L693.471 -55.6729V55.6729L789.548 111.346L885.624 55.6729V-55.6729L789.548 -111.259Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.358 55.4115V-55.4115L987 -110.823L1082.64 -55.4115V55.4115L987 110.823L891.358 55.4115Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987 -110.3L1082.21 -55.1501V55.1501L987 110.3L891.792 55.1501V-55.1501L987 -110.3ZM987 -111.259L890.923 -55.5858V55.6729L987 111.346L1083.08 55.6729V-55.6729L987 -111.259Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-95.6423 403.912V293.088L-7.62939e-05 237.677L95.6422 293.088V403.912L-7.62939e-05 459.323L-95.6423 403.912Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.28882e-05 238.2L95.2079 293.35V403.65L-2.28882e-05 458.8L-95.2079 403.65V293.35L-2.28882e-05 238.2ZM-2.28882e-05 237.241L-96.0766 292.914V404.173L-2.28882e-05 459.759L96.0766 404.086V292.827L-2.28882e-05 237.241Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.723 403.912V293.088L197.365 237.677L293.094 293.088V403.912L197.365 459.323L101.723 403.912Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.365 238.2L292.573 293.35V403.65L197.365 458.8L102.157 403.65V293.35L197.365 238.2ZM197.365 237.241L101.289 292.914V404.173L197.365 459.846L293.442 404.173V292.827L197.365 237.241Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.175 403.912V293.088L394.817 237.677L490.46 293.088V403.912L394.817 459.323L299.175 403.912Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.817 238.2L490.025 293.35V403.65L394.817 458.8L299.609 403.65V293.35L394.817 238.2ZM394.817 237.241L298.741 292.914V404.173L394.817 459.846L490.894 404.173V292.827L394.817 237.241Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.54 403.912V293.088L592.183 237.677L687.825 293.088V403.912L592.183 459.323L496.54 403.912Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.183 238.2L687.391 293.35V403.65L592.183 458.8L496.975 403.65V293.35L592.183 238.2ZM592.183 237.241L496.106 292.914V404.173L592.183 459.846L688.259 404.173V292.827L592.183 237.241Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.906 403.912V293.088L789.548 237.677L885.277 293.088V403.912L789.548 459.323L693.906 403.912Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.548 238.2L884.756 293.35V403.65L789.548 458.8L694.34 403.65V293.35L789.548 238.2ZM789.548 237.241L693.471 292.914V404.173L789.548 459.846L885.624 404.173V292.827L789.548 237.241Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.358 403.912V293.088L987 237.677L1082.64 293.088V403.912L987 459.323L891.358 403.912Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987 238.2L1082.21 293.35V403.65L987 458.8L891.792 403.65V293.35L987 238.2ZM987 237.241L890.923 292.914V404.173L987 459.846L1083.08 404.173V292.827L987 237.241Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-95.6423 752.411V641.589L-7.62939e-05 586.177L95.6422 641.589V752.411L-7.62939e-05 807.823L-95.6423 752.411Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.28882e-05 586.7L95.2079 641.85V752.15L-2.28882e-05 807.3L-95.2079 752.15V641.85L-2.28882e-05 586.7ZM-2.28882e-05 585.741L-96.0766 641.414V752.673L-2.28882e-05 808.259L96.0766 752.586V641.327L-2.28882e-05 585.741Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.723 752.411V641.589L197.365 586.177L293.094 641.589V752.411L197.365 807.823L101.723 752.411Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.365 586.7L292.573 641.85V752.15L197.365 807.3L102.157 752.15V641.85L197.365 586.7ZM197.365 585.741L101.289 641.414V752.673L197.365 808.346L293.442 752.673V641.327L197.365 585.741Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.175 752.411V641.589L394.817 586.177L490.46 641.589V752.411L394.817 807.823L299.175 752.411Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.817 586.7L490.025 641.85V752.15L394.817 807.3L299.609 752.15V641.85L394.817 586.7ZM394.817 585.741L298.741 641.414V752.673L394.817 808.346L490.894 752.673V641.327L394.817 585.741Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.54 752.411V641.589L592.183 586.177L687.825 641.589V752.411L592.183 807.823L496.54 752.411Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.183 586.7L687.391 641.85V752.15L592.183 807.3L496.975 752.15V641.85L592.183 586.7ZM592.183 585.741L496.106 641.414V752.673L592.183 808.346L688.259 752.673V641.327L592.183 585.741Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.906 752.411V641.589L789.548 586.177L885.277 641.589V752.411L789.548 807.823L693.906 752.411Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.548 586.7L884.756 641.85V752.15L789.548 807.3L694.34 752.15V641.85L789.548 586.7ZM789.548 585.741L693.471 641.414V752.673L789.548 808.346L885.624 752.673V641.327L789.548 585.741Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.358 752.411V641.589L987 586.177L1082.64 641.589V752.411L987 807.823L891.358 752.411Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987 586.7L1082.21 641.85V752.15L987 807.3L891.792 752.15V641.85L987 586.7ZM987 585.741L890.923 641.414V752.673L987 808.346L1083.08 752.673V641.327L987 585.741Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04041 579.033V468.21L98.6826 412.798L194.325 468.21V579.033L98.6826 634.357L3.04041 579.033Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6827 413.321L193.891 468.471V578.771L98.6827 633.921L3.47476 578.771V468.471L98.6827 413.321ZM98.6827 412.363L2.60608 467.948V579.207L98.6827 634.88L194.759 579.207V467.948L98.6827 412.363Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.406 579.033V468.21L296.135 412.798L391.777 468.21V579.033L296.135 634.357L200.406 579.033Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.135 413.321L391.343 468.471V578.771L296.135 633.921L200.927 578.771V468.471L296.135 413.321ZM296.135 412.363L200.058 468.036V579.294L296.135 634.967L392.211 579.294V467.948L296.135 412.363Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.858 579.033V468.21L493.5 412.798L589.142 468.21V579.033L493.5 634.357L397.858 579.033Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.5 413.321L588.708 468.471V578.771L493.5 633.921L398.292 578.771V468.471L493.5 413.321ZM493.5 412.363L397.423 468.036V579.294L493.5 634.967L589.577 579.294V467.948L493.5 412.363Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.223 579.033V468.21L690.865 412.798L786.508 468.21V579.033L690.865 634.357L595.223 579.033Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.865 413.321L786.073 468.471V578.771L690.865 633.921L595.657 578.771V468.471L690.865 413.321ZM690.865 412.363L594.789 468.036V579.294L690.865 634.967L786.942 579.294V467.948L690.865 412.363Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.588 579.033V468.21L888.317 412.798L983.96 468.21V579.033L888.317 634.357L792.588 579.033Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.317 413.321L983.525 468.471V578.771L888.317 633.921L793.11 578.771V468.471L888.317 413.321ZM888.317 412.363L792.241 468.036V579.294L888.317 634.967L984.394 579.294V467.948L888.317 412.363Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04041 229.574V118.838L98.6826 63.427L194.325 118.838V229.574L98.6826 284.986L3.04041 229.574Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6827 63.9497L193.891 119.1V229.4L98.6827 284.55L3.47476 229.313V119.1L98.6827 63.9497ZM98.6827 62.9042L2.60608 118.577V229.836L98.6827 285.509L194.759 229.836V118.577L98.6827 62.9042Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.406 229.574V118.838L296.135 63.427L391.777 118.838V229.574L296.135 284.986L200.406 229.574Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.135 63.9497L391.343 119.1V229.4L296.135 284.55L200.927 229.4V119.1L296.135 63.9497ZM296.135 62.9042L200.058 118.577V229.836L296.135 285.509L392.211 229.836V118.577L296.135 62.9042Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.858 229.574V118.838L493.5 63.427L589.142 118.838V229.574L493.5 284.986L397.858 229.574Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.5 63.9497L588.708 119.1V229.4L493.5 284.55L398.292 229.4V119.1L493.5 63.9497ZM493.5 62.9042L397.423 118.577V229.836L493.5 285.509L589.577 229.836V118.577L493.5 62.9042Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.223 229.574V118.838L690.865 63.427L786.508 118.838V229.574L690.865 284.986L595.223 229.574Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.865 63.9497L786.073 119.1V229.4L690.865 284.55L595.657 229.4V119.1L690.865 63.9497ZM690.865 62.9042L594.789 118.577V229.836L690.865 285.509L786.942 229.836V118.577L690.865 62.9042Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.588 229.574V118.838L888.317 63.427L983.96 118.838V229.574L888.317 284.986L792.588 229.574Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.317 63.9497L983.525 119.1V229.4L888.317 284.55L793.11 229.4V119.1L888.317 63.9497ZM888.317 62.9042L792.241 118.577V229.836L888.317 285.509L984.394 229.836V118.577L888.317 62.9042Z",
    fill: "#161616"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 987,
    height: 697,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.4a0ef1f77fa6c3d0868449c016502db4.svg";
export { ForwardRef as ReactComponent };